(function () {
  var MARKER_START = '--- Corporate Invoice ---';
  var MARKER_END = '--- End Corporate Invoice ---';
  var STORAGE_KEY = 'vatpan_corporate_invoice';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function stripCorporateBlock(note) {
    if (!note) return '';
    var start = note.indexOf(MARKER_START);
    if (start === -1) return note.trim();
    var end = note.indexOf(MARKER_END, start);
    if (end === -1) return note.slice(0, start).trim();
    return (note.slice(0, start) + note.slice(end + MARKER_END.length))
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  function parseCorporateBlock(note) {
    var data = { enabled: false, company: '', taxId: '', taxOffice: '' };
    if (!note) return data;
    var start = note.indexOf(MARKER_START);
    if (start === -1) return data;
    var end = note.indexOf(MARKER_END, start);
    var block = end === -1 ? note.slice(start) : note.slice(start, end);
    data.enabled = true;
    var companyMatch = block.match(/Company Name:\s*(.*)/i);
    var taxIdMatch = block.match(/Tax ID:\s*(.*)/i);
    var taxOfficeMatch = block.match(/Tax Office:\s*(.*)/i);
    if (companyMatch) data.company = companyMatch[1].trim();
    if (taxIdMatch) data.taxId = taxIdMatch[1].trim();
    if (taxOfficeMatch) data.taxOffice = taxOfficeMatch[1].trim();
    return data;
  }

  function buildCorporateBlock(company, taxId, taxOffice) {
    return [
      MARKER_START,
      'Company Name: ' + company,
      'Tax ID: ' + taxId,
      'Tax Office: ' + taxOffice,
      MARKER_END,
    ].join('\n');
  }

  function readStorage() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(payload) {
    try {
      if (!payload || !payload.enabled) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function init(root) {
    if (!root || root.dataset.corporateInvoiceReady === 'true') return;
    root.dataset.corporateInvoiceReady = 'true';

    var form = root.closest('form');
    var noteHidden = form ? qs(form, '[data-cart-note]') : null;
    var noteUser = form ? qs(form, '[data-cart-note-user]') : null;
    var toggle = qs(root, '[data-corporate-invoice-toggle]');
    var fields = qs(root, '[data-corporate-invoice-fields]');
    var companyEl = qs(root, '[data-corporate-invoice-company]');
    var taxIdEl = qs(root, '[data-corporate-invoice-tax-id]');
    var taxOfficeEl = qs(root, '[data-corporate-invoice-tax-office]');

    if (!toggle || !fields || !companyEl || !taxIdEl || !taxOfficeEl || !noteHidden) return;

    var sourceNote = (noteHidden.value || (noteUser && noteUser.value) || '').toString();
    var parsed = parseCorporateBlock(sourceNote);
    var stored = readStorage();
    var userNote = stripCorporateBlock(sourceNote);

    if (!parsed.enabled && stored && stored.enabled) {
      parsed = stored;
    }

    if (noteUser) {
      noteUser.value = userNote;
    }

    if (parsed.enabled) {
      toggle.checked = true;
      companyEl.value = parsed.company || '';
      taxIdEl.value = parsed.taxId || '';
      taxOfficeEl.value = parsed.taxOffice || '';
      fields.hidden = false;
      root.classList.add('is-open');
    }

    function syncNote() {
      var base = noteUser ? (noteUser.value || '').trim() : '';
      if (!toggle.checked) {
        noteHidden.value = base;
        writeStorage({ enabled: false });
        return;
      }

      var company = (companyEl.value || '').trim();
      var taxId = (taxIdEl.value || '').trim();
      var taxOffice = (taxOfficeEl.value || '').trim();
      writeStorage({
        enabled: true,
        company: company,
        taxId: taxId,
        taxOffice: taxOffice,
      });

      if (!company && !taxId && !taxOffice) {
        noteHidden.value = base;
        return;
      }

      var block = buildCorporateBlock(company, taxId, taxOffice);
      noteHidden.value = base ? base + '\n\n' + block : block;
    }

    function setOpen(open) {
      fields.hidden = !open;
      root.classList.toggle('is-open', open);
      if (!open) {
        companyEl.value = '';
        taxIdEl.value = '';
        taxOfficeEl.value = '';
      }
      syncNote();
    }

    toggle.addEventListener('change', function () {
      setOpen(toggle.checked);
    });

    [companyEl, taxIdEl, taxOfficeEl].forEach(function (el) {
      el.addEventListener('input', syncNote);
      el.addEventListener('change', syncNote);
    });

    if (noteUser) {
      noteUser.addEventListener('input', syncNote);
      noteUser.addEventListener('change', syncNote);
    }

    form.addEventListener('submit', syncNote);

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest(
          '[name="checkout"], .shopify-payment-button button, .shopify-payment-button__button'
        );
        if (!btn || !form.contains(btn)) return;
        syncNote();
      },
      true
    );

    syncNote();
  }

  function boot() {
    document.querySelectorAll('[data-corporate-invoice]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  var cartRoot = document.querySelector('.cart--section');
  if (cartRoot && typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        boot();
      });
    }).observe(cartRoot, { childList: true, subtree: true });
  }
})();
